import { reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import withRouter from '../../shared/utils/WithRouter';
import { openCancelConfirmModal, setApplicationFormData } from 'redux/domain/App';
import toJS from 'shared/components/toJS';
import ApplicationReview from './ApplicationReview';

const mapStateToProps = state => {
	const settings = state.cache.get('settings');
	const applicantIndicator = state.welcome.get('applicantIndicator');
	const userConsented = state.welcome.get('userConsented');
	return {
		settings,
		formValues: getFormValues('ApplicationEntry')(state),
		active: state.form.ApplicationEntry && state.form.ApplicationEntry.active,
		applicantIndicator,
		userConsented,
	};
};

const mapDispatchToProps = {
	openCancelConfirmModal,
	setApplicationFormData,
};

// generate a route-aware container component
const ApplicationReviewContainer = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(
		reduxForm({
			form: 'ApplicationEntry',
			destroyOnUnmount: false, // keep form data after component unmounts
			forceUnregisterOnUnmount: true,
		})(toJS(ApplicationReview)),
	),
);

export default ApplicationReviewContainer;
export { mapStateToProps }; // for testing purposes only
